import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import './output.css';
import './swal-overrides.css';

const AppIndex = () => {
  return (
    <App />
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <AppIndex />
    </Router>
  </React.StrictMode>
);
